<template>
  <div class="home">
    <navbar-menu class="is-hidden-tablet" />
    <div class="columns is-multiline">
      <div
        class="column is-2-desktop is-4-tablet is-12-mobile is-hidden-mobile"
      >
        <sidebar-menu />
      </div>
      <div class="column is-10-desktop is-8-tablet">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SidebarMenu from "@/components/menus/SidebarMenu.vue";
import NavbarMenu from "@/components/menus/NavbarMenu.vue";

export default {
  name: "Home",
  components: {
    SidebarMenu,
    NavbarMenu
  }
};
</script>
